var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStop2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 277,
    height: 356,
    viewBox: "0 0 277 356",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_115_1485)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M214.414 0H65.487C29.716 0 0 31.595 0 67.365V216.293C0 251.994 29.716 281.57 65.486 281.57H97.637L114.27 310.59L139.949 355.547L165.629 310.799L182.262 281.57H214.413C250.113 281.57 276.142 251.994 276.142 216.293V67.365C276.142 31.595 250.114 0 214.414 0Z",
    fill: "#131312"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.639 209C100.372 209 97.239 208.067 95.239 206.2C93.3723 204.2 92.439 201.333 92.439 197.6C92.439 195.333 93.039 193.133 94.239 191C95.439 188.867 97.1723 186.6 99.439 184.2L139.639 141.4C145.772 135 150.172 129.2 152.839 124C155.506 118.667 156.839 113.333 156.839 108C156.839 101.333 154.706 96.2667 150.439 92.8C146.306 89.3333 140.239 87.6 132.239 87.6C127.706 87.6 123.172 88.2667 118.639 89.6C114.106 90.8 109.506 92.9333 104.839 96C102.439 97.6 100.172 98.2667 98.039 98C96.039 97.7333 94.239 96.8667 92.639 95.4C91.1723 93.9333 90.1723 92.1333 89.639 90C89.1057 87.8667 89.1723 85.7333 89.839 83.6C90.639 81.3333 92.239 79.4 94.639 77.8C100.372 73.9333 106.772 71 113.839 69C121.039 67 128.239 66 135.439 66C145.572 66 154.106 67.5333 161.039 70.6C167.972 73.6667 173.239 78.1333 176.839 84C180.439 89.8667 182.239 97 182.239 105.4C182.239 111 181.306 116.467 179.439 121.8C177.706 127.133 174.972 132.533 171.239 138C167.639 143.467 162.906 149.267 157.039 155.4L119.439 194.6V187.8H178.239C181.839 187.8 184.572 188.667 186.439 190.4C188.306 192.133 189.239 194.733 189.239 198.2C189.239 201.667 188.306 204.333 186.439 206.2C184.572 208.067 181.839 209 178.239 209H104.639Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_115_1485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 276.196,
    height: 355.547,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStop2);
export default __webpack_public_path__ + "static/media/stop2.89d0e14f16a7caa6a7effb2f7eb677df.svg";
export { ForwardRef as ReactComponent };